import teacherInfoDescriptionMap, {
  teacherInfoIconBlock,
} from "../../../components/InfoIcon/teacherInfoIcon"

const cards = [
  {
    title: "This month renewal rate",
    progress: 80,
    logoBg: "#E01E5A",
    logo: "mark",
    diff: 5,
    time: "vs last month",
    isPercent: true,
    information: teacherInfoDescriptionMap.get(
      teacherInfoIconBlock.THIS_MONTH_RENEWAL_RATE
    ),
  },
  {
    title: "Welearn course progress",
    progress: 50,
    logoBg: "#E01E5A",
    logo: "mark",
    diff: 5,
    time: "vs last week",
    isPercent: true,
    information: teacherInfoDescriptionMap.get(
      teacherInfoIconBlock.WELEARN_COURSE_PROGRESS
    ),
  },
  {
    title: "Teaching hour",
    progress: 85,
    logoBg: "#E01E5A",
    logo: "mark",
    diff: 5,
    time: "vs last month",
    isPercent: false,
    information: teacherInfoDescriptionMap.get(
      teacherInfoIconBlock.TEACHING_HOUR
    ),
  },
  {
    title: "Conversion rate ",
    progress: 65,
    logoBg: "#E01E5A",
    logo: "mark",
    diff: +2,
    time: "vs last month",
    isPercent: true,
    information: teacherInfoDescriptionMap.get(
      teacherInfoIconBlock.CONVERSION_RATE
    ),
  },
]

const cardsLXO = [
  {
    title: "Pending tasks today",
    progress: 5,
    logoBg: "#FF8C42",
    accentColor: "#FF8C42",
    logo: "pending-task",
    diff: 0,
    time: "",
    isPercent: false,
    information: teacherInfoDescriptionMap.get(
      teacherInfoIconBlock.LXO_PENDING_TASKS_TODAY
    ),
  },
  {
    title: "App completion",
    progress: 81,
    logoBg: "#1576BC",
    accentColor: "#1576BC",
    logo: "app-completion",
    diff: -2,
    time: "vs last week",
    isPercent: true,
    information: teacherInfoDescriptionMap.get(
      teacherInfoIconBlock.LXO_APP_COMPLETION
    ),
  },
  {
    title: "Workbook completion",
    progress: 81,
    logoBg: "#7B5EA7",
    accentColor: "#7B5EA7",
    logo: "workbook-completion",
    diff: -2,
    time: "vs last week",
    isPercent: true,
    information: teacherInfoDescriptionMap.get(
      teacherInfoIconBlock.LXO_WORKBOOK_COMPLETION
    ),
  },
  {
    title: "Teacher change rate",
    progress: 5,
    logoBg: "#00B4A2",
    accentColor: "#00B4A2",
    logo: "teacher-change-rate",
    diff: -2,
    time: "vs last week",
    isPercent: true,
    information: teacherInfoDescriptionMap.get(
      teacherInfoIconBlock.LXO_TEACHER_CHANGE_RATE
    ),
  },
  {
    title: "Teacher efficiency",
    progress: 5,
    logoBg: "#4361EE",
    accentColor: "#4361EE",
    logo: "teacher-efficiency",
    diff: -2,
    time: "vs last week",
    isPercent: true,
    information: teacherInfoDescriptionMap.get(
      teacherInfoIconBlock.LXO_TEACHER_EFFICIENCY
    ),
  },
  {
    title: "Cancellation rate",
    progress: 5,
    logoBg: "#E63757",
    accentColor: "#E63757",
    logo: "cancellation-rate",
    diff: -2,
    time: "vs last week",
    isPercent: true,
    information: teacherInfoDescriptionMap.get(
      teacherInfoIconBlock.LXO_CANCELLATION_RATE
    ),
  },
]

export { cards, cardsLXO }
